module.exports = __webpack_public_path__ + "static/media/img-function-interview@2x.599a69d6.png";